export default __webpack_public_path__ + "static/media/FactoryIconBlue.15b24c9d.svg";